import { auth, db } from '../../firebase';
import firebase from "firebase/app";
import { hideLoadingAction, showLoadingAction } from '../loading/actions';
import { signInAction } from './actions';
import { push } from 'connected-react-router';

const usersRef = db.collection('users')

export const signInWithGoogle = () => {
    return async (dispatch) => {
        dispatch(showLoadingAction("Sign in..."));
        var provider = new firebase.auth.GoogleAuthProvider();
        return auth.signInWithPopup(provider)
            .then((result) => {
                // The signed-in user info.
                var user = result.user;

                return usersRef.doc(user.uid).get()
                    .then((doc) => {
                        if (!doc.exists) {
                            usersRef.doc(user.uid).set({
                                // uid: user.uid,
                                counter: 1,
                                updateYMD: Date.now()
                            })
                        }
                        dispatch(signInAction({isSignedIn: true}))
                        dispatch(hideLoadingAction())
                        dispatch(push('/'))
                    })
                    .catch((error) => {
                        dispatch(hideLoadingAction())
                        alert(error.message)
                    })

                
                // ...
            }).catch((error) => {
                dispatch(hideLoadingAction())
                alert(error.message)
                // ...
            });
    }    // var provider = new auth.GoogleAuthProvider();
}

export const signInWithEmailAndPassword = (email, password) => {
    return async (dispatch) => {
        dispatch(showLoadingAction("Sign in..."));
        return auth.signInWithEmailAndPassword(email, password)
            .then((userCredential) => {
                // Signed in
                var user = userCredential.user;
                dispatch(signInAction({isSignedIn: true}))
                dispatch(hideLoadingAction())
                dispatch(push('/'))
            })
            .catch((error) => {
                dispatch(hideLoadingAction())
                alert(error.message)
        });
    }
}

export const listenAuthState = () => {
    return async (dispatch) => {
        return auth.onAuthStateChanged((user) => {
            if (user) {
                dispatch(signInAction({isSignedIn: true}))
            }
            else {
                dispatch(signInAction({isSignedIn: false}))
            }
        })
    }
}

export const signUp = (email, password) => {
    return async (dispatch) => {
        return auth.createUserWithEmailAndPassword(email, password)
            .then((userCredential) => {
                // Signed in
                const user = userCredential.user;
                if (user) {
                    dispatch(showLoadingAction("Sign up..."))
                    // ...
                    usersRef.doc(user.uid).get()
                        .then((doc) => {
                            if (!doc.exists) {
                                usersRef.doc(user.uid).set({
                                    // uid: user.uid,
                                    counter: 1,
                                    updateYMD: firebase.firestore.Timestamp.now()
                                })
                                dispatch(hideLoadingAction())
                                dispatch(push('/'))
                            }
                        })
                        
                        .catch((error) => {
                            alert(error)
                        })
                }
            })
                // TODO:エラー処理めんどくさいなぁ
            .catch((error) => {
                dispatch(hideLoadingAction())
                var errorCode = error.code;
                var errorMessage = error.message;
                alert(errorMessage)
            });
    }
}

export const signOut = () => {
    return async (dispatch) => {
        console.log("s")
        dispatch(showLoadingAction("Sign out..."));
        return auth.signOut()
            .then(() => {
                dispatch(hideLoadingAction())
                dispatch(push('/'))
            })
            .catch((error) => {
                alert(error)
            })
    }
}